import * as mutationTypes from './mutation-types'
import api from '../api/comment'

const Comments = {
  state() {
    return {
      comments: {},
    }
  },

  getters: {
    commentsByIds: (state) => (ids) => {
      return ids.map((id) => state.comments[id])
    },

    commentById: (state) => (id) => {
      return state.comments[id]
    },
  },

  mutations: {
    [mutationTypes.SET_COMMENTS](state, comments) {
      state.comments = comments
    },

    [mutationTypes.ADD_COMMENT](state, { comment, commentable }) {
      commentable.commentIds.push(comment.id)
      state.comments[comment.id] = comment
    },

    [mutationTypes.EDIT_COMMENT](state, { comment }) {
      state.comments[comment.id] = comment
    },
  },

  actions: {
    async postComment(
      { commit, dispatch, rootGetters, rootState },
      [commentableId, type, params]
    ) {
      const [mutation, commentable] =
        type === 'Remark'
          ? [
              mutationTypes.REMOVE_NEW_COMMENT_REMARK_ID,
              rootGetters.remarkById(commentableId),
            ]
          : [
              mutationTypes.REMOVE_NEW_COMMENT_CHECK_ID,
              rootGetters.checkById(commentableId),
            ]

      const comment = await api.postComment(
        commentableId,
        type,
        params,
        rootState.companyId ||
          rootState.notifications.activeCompanyId ||
          Silverfin.currentCompanyId
      )

      commit(mutationTypes.ADD_COMMENT, { comment, commentable })

      dispatch('fetchCommunication')
      dispatch(
        'fetchNotifications',
        rootState.companyId ||
          rootState.notifications.activeCompanyId ||
          Silverfin.currentCompanyId
      )
      window.eventHub.$emit('scrollToElement', {
        elementType: 'remark',
        elementId: commentableId,
      })
      window.eventHub.$emit('resetNotificationCount')
      commit(mutation, { id: commentableId })

      return comment
    },

    async editComment(
      { commit, dispatch, rootState },
      [commentableId, type, commentId, params]
    ) {
      const comment = await api.editComment(
        commentableId,
        type,
        commentId,
        params,
        rootState.companyId ||
          rootState.notifications.activeCompanyId ||
          Silverfin.currentCompanyId
      )

      commit(mutationTypes.EDIT_COMMENT, { comment })

      dispatch('fetchCommunication')
      window.eventHub.$emit('scrollToElement', {
        elementType: type.toLowerCase(),
        elementId: commentableId,
      })
      commit(mutationTypes.REMOVE_EDIT_COMMENT_ID, { id: commentId })

      return comment
    },

    async removeComment(
      { dispatch, rootState },
      [commentableId, commentableType, commentId]
    ) {
      await api.destroyComment(
        commentId,
        rootState.companyId ||
          rootState.notifications.activeCompanyId ||
          Silverfin.currentCompanyId,
        commentableType,
        commentableId
      )
      await dispatch('fetchCommunication')
    },
  },
}

export default Comments
